import { render, staticRenderFns } from "./groupNPermission.vue?vue&type=template&id=514cf0c8&scoped=true&"
import script from "./groupNPermission.vue?vue&type=script&lang=js&"
export * from "./groupNPermission.vue?vue&type=script&lang=js&"
import style0 from "./groupNPermission.vue?vue&type=style&index=0&id=514cf0c8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514cf0c8",
  null
  
)

export default component.exports